export default {
  baseball: 'baseball/mlb',
  football: 'football/nfl',
  hockey: 'hockey/nhl',
  basketball: 'basketball/nba',
};
